import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
const messageSchema = Yup.object().shape({
  message: Yup.string().required(i18n.t('mix.message_required'))
});

// Types
export type MessageData = Yup.InferType<typeof messageSchema>;

// Resolvers
export const messageResolver = yupResolver(messageSchema);
